import { getItemMaker } from "./tools";

const i = getItemMaker("keychains");
export const keychains = [
  i("Simple Key Chain", "EquipmentKeychain0"),
  i("Leafy Chain", "EquipmentKeychain1"),
  i("Red Sneaker Chain", "EquipmentKeychain2"),
  i("Wartooth Chain", "EquipmentKeychain3"),
  i("8 Ball Chain", "EquipmentKeychain4"),
  i("Piggy Chain", "EquipmentKeychain5"),
  i("Dumbphone Chain", "EquipmentKeychain6"),
  i("Horn Chain", "EquipmentKeychain7"),
  i("Rustic Key Chain", "EquipmentKeychain8"),
  i("Taco Chain", "EquipmentKeychain9"),
  i("Cactus Chain", "EquipmentKeychain10"),
  i("Relic Chain", "EquipmentKeychain11"),
  i("Balloon Dog Chain", "EquipmentKeychain12"),
  i("Frozen Tart Chain", "EquipmentKeychain13"),
  i("Whatamelon Chain", "EquipmentKeychain14"),
  i("9 Ball Chain", "EquipmentKeychain15"),
  i("Pincer Hand Chain", "EquipmentKeychain16"),
  i("Gilded Key Chain", "EquipmentKeychain17"),
  i("Sushi Chain", "EquipmentKeychain18"),
  i("Time Candy Chain", "EquipmentKeychain19"),
  i("Star Blobulyte Galaxy Chain", "EquipmentKeychain20"),
  i("Mmm Donut Chain", "EquipmentKeychain21"),
  i("Negative 7 Chain", "EquipmentKeychain22"),
  i("Diamond Honker Chain", "EquipmentKeychain23"),
  i("BobGoldPickle Chain", "EquipmentKeychain24"),
  i("Eye Owe Ess Chain", "EquipmentKeychain25"),
  i("Key to Desert Chain", "EquipmentKeychain26"),
  i("Key to Mountains Chain", "EquipmentKeychain27"),
  i("Key to Purgatory Chain", "EquipmentKeychain28"),
  i("Spiritlord Horn Chain", "EquipmentKeychain29"),
];
